import * as TypeActions from './actionsTypes';

const initialState = {
  nsirs: [],
  loadingNsirs: false,
};

const reducer = (state = initialState, action) => {
  const base = {
    ...initialState,
    ...state,
    loadingNsirs: state?.loadingNsirs ?? state?.loading ?? false,
  };

  switch (action.type) {
    case TypeActions.NSIR_MAPA_LOAD_COMPLETO:
      return {
        ...base,
        loadingNsirs: true,
      };
    case TypeActions.NSIR_MAPA_FIND_SUCCESS:
      return {
        ...base,
        nsirs: action.data,
        loadingNsirs: false,
      };
    case TypeActions.NSIR_MAPA_CLEAN_ALL:
      return { ...initialState };
    default:
      return base;
  }
};

export const getNsirsForMapa = (state) => state.rootState.nsirMapa?.nsirs ?? [];
export const getNsirMapaLoadingNsirs = (state) => {
  const slice = state.rootState?.nsirMapa;
  if (!slice) return false;
  return slice.loadingNsirs ?? slice.loading ?? false;
};

export default reducer;
